import type { ApiSearchQuery } from "@/lib/api/api-type-helper";
import { apiClient } from "@/lib/api/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const SearchSchema = z.object({
  text: z.string().default(""),
  categoryId: z.string().optional(),
});

export const Route = createFileRoute("/_staff/apps/_list/marketplace/")({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search } }) => {
    type Query = ApiSearchQuery<"/v2/apps", "get">;

    const [res1, res2] = await Promise.all([
      apiClient.GET("/v2/apps", {
        params: {
          query: {
            categoryId: search.categoryId as Query["categoryId"],
            freeText: search.text,
          },
        },
      }),
      apiClient.GET("/v2/app-categories"),
    ]);

    if (!res1.data) throw new Error("Failed to fetch apps");
    if (!res2.data) throw new Error("Failed to fetch app categories");

    return {
      apps: res1.data,
      categories: res2.data,
    } as const;
  },
});
